<template >
  <div class="tryOut" :style="isH5 ? 'height: 100%': ''" :class="{'onboard': onboard}" v-if="isH5 || !ifHomePage">
    <div class="inner" :style="onboard ? innerStyleOnboard : innerStyle" v-if="!isH5">
      <div class="w1200">
        <hm-img v-if="!onboard" imgClass="logo-slogan-img" type="images/tryout/logo" imgName="logo_slogan_pc_zh" align="center" />
        <hm-img v-else imgClass="logo-slogan-img" type="images/tryout/logo" :imgName="onboard" align="center" />
        <div class="content-box">
          <div class="boxleft">
            <div>
              <hm-img type="images/tryout" :imgName="!productType && !onboard ? 'tryout_bc_01_zh' : productType" imgClass="tryout_bc_productType"/>
            </div>
          </div>
          <div class="boxright">
            <div class="boxright_title">申请免费体验</div>
            <hmApply v-if="!onboard" :isShowLabelText="false"/>
            <hmApplyOnboard v-else :isShowLabelText="false" :onboard="onboard" :productType="productType" :showLabel="onboard ? showLabelOnboard : showLabel"/>
          </div>
        </div>
      </div>
    </div>
    <div class="inner-h5" :style="h5InnerStyle" v-else>
      <div class="inner-h5-wrap">
        <hm-img imgClass="logo-slogan-img" type="images/tryout/logo" imgName="logo_slogan_h5_zh" />
        <div class="contactText">联系我们，获取专业解决方案</div>
        <div class="apply-wrap">
          <div class="apply-main">
            <!-- <p class="apply-title">申请免费体验</p> -->
            <hmApply :isShowLabelText="false" :onboard="onboard" :productType="productType" :showLabel="onboard ? showLabelOnboard : showLabel"/>
          </div>
          <!-- <div class="apply-footer">
            <span class="tryOut-slogan">助力企业低成本智慧税务运营</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// onboard: zaefi,qie
// productType: declaration,Taxcellent,lawLibrary,chataxera,airTax,exportTaxRebate
import hmApply from '@/components/hm-apply'
import hmApplyOnboard from '@/components/hm-apply/apply-onboard'

import { mapGetters } from 'vuex'
export default {
  metaInfo () {
    return this.$route.meta.metaInfo || null
  },
  name: 'tryOut',
  props: {
    path: {
      type: String
    },
    showLabel: {
      type: Array,
      default: () => ['phoneNo', 'verificationCode', 'enterpriseName']
    },
    showAgreement: { // 是否显示隐私政策
      type: Boolean,
      default: true
    }
  },
  components: {
    hmApply,
    hmApplyOnboard
  },
  computed: {
    ...mapGetters(['isH5']),
    ifHomePage () {
      return this.$route.path === '/home'
    }
  },
  mounted () {
    this.onboard = this.$route.query.onboard
    this.productType = this.$route.query.productType
    console.log('%c query', 'background-color: green;color: #fff;', this.onboard, this.productType)
  },
  data () {
    return {
      showLabelOnboard: ['phoneNo', 'verificationCode', 'message'],
      onboard: undefined,
      productType: undefined,
      total: 60,
      form: {
        phone: '',
        code: '',
        componyName: ''
      },
      checked: false,
      innerStyle: {
        backgroundImage: 'url(' + require('@/assets/images/tryout_bc_02_zh.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top'
      },
      h5InnerStyle: {
        backgroundImage: 'url(' + require('@/assets/images/tryOut_h5bg_01_zh.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 24rem',
        backgroundPosition: 'top'
      },
      innerStyleOnboard: {
        backgroundImage: 'url(' + require('@/assets/images/tryout/banner.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }
    }
  },
  methods: {
    checkChange (e) {
      this.checked = e.target.checked
    },
    toPage (path) {
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="less" scoped>
.tryOut-slogan {
  background-image: linear-gradient(to right, #3E77FF, #3BA7FC, #25C9B0);
  -webkit-background-clip: text;
  color: transparent;
}
.tryOut {
  height: 900PX;

  .inner {
    text-align: center;
    padding-top: 100PX;
    width: 100%;
    height: 400PX;
    background-color: #6386ff;
    .w1200 {
      width: 1200PX !important;
      margin: 0 auto;
    }
    .title {
      font-size: 42PX;
      font-stretch: normal;
      line-height: 56PX;
      letter-spacing: 0PX;
      color: #ffffff;
      font-weight: 600;
    }
    .tips {
      color: #ffffff;
      font-size: 18PX;
      font-weight: normal;
      font-stretch: normal;
      line-height: 56PX;
      letter-spacing: 0PX;
      color: #ffffff;
      margin-top: 10PX;
    }
    .content-box {
      height: 500PX;
      background-color: #fff;
      margin-top: 117PX;
      box-shadow: 0 2PX 4PX 0 rgba(4,10,51,0.06);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 100PX;
      border-radius: 8PX;
      box-sizing: border-box;
      .boxLeftTop {
        display: flex;
        justify-content: center;
        margin-bottom: 56PX;
        .text {
          font-size: 24PX;
          text-align: center;
          font-weight: 600;
          .tryOut-slogan
        }
        .text2 {
          font-size: 16PX;
          color: #607296;
          font-weight: 500;
        }
      }
      .boxleft {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 513PX;
        height: 500PX;
        padding-top: 0PX;
        .img {
          margin: 0 auto;
        }
      }
      // .boxleft.productType {
      //   // width: 752PX;
      //   padding-top: 0;
      // }
      .boxright {
        width: 328PX;
        // height: 260PX;
        .boxright_title{
          font-size: 24PX;
          color: #000000;
          font-weight: 600;
          margin-bottom: 32PX;
        }
        input{
          font-size: 13PX !important
        }
        .code {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .agree {
          margin-top: 20PX;
          text-align: left;
          color: #848d9e;
          span {
            color: #3e77ff;
          }
        }
        .componyname{
          input {
            height: 40PX;
          }
        }
        .ant-form-item{
          margin-bottom: 10PX;
        }
      }
    }
  }
  .inner-h5 {
    padding-top: 3.2rem;
    margin-bottom: 1.4rem;
    text-align: center;
    .inner-h5-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .contactText {
        margin: 0 auto;
        margin-top: 16px;
        font-size: 28px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 24px;
        font-weight: 400;
      }
    }
    .apply-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 33.5rem;
      // height: 35.4rem;
      height: 620px;
      margin-top: 48px;
      padding-top: 2.35rem;
      background-color: #fff;
      border-radius: 0.8rem;
      .apply-title {
        margin-bottom: 2rem;
        font-size: 1.6rem;
        font-weight: 500;
        color: #292F3A;
      }
      .apply-footer {
        height: 6.4rem;
        line-height: 6.4rem;
        // opacity: 0.1;
        background-image: linear-gradient(180deg, #F9FBFF 0%, #F1F7FF 100%);
        border-radius: 0 0 0.8rem 0.8rem;
        .tryOut-slogan {
          font-size: 1.6rem;
        }
      }
    }
  }
}
.tryOut.onboard {
  height: 100%;
  background: #F7F9FB;
}
</style>

<style lang="less">
.tryout_bc {
  width: 513PX;
  height: 266PX;
  /* margin: 70PX auto 0; */
}
.tryout_bc_productType {
  width: 752PX;
  height: 500PX;
}
.ant-checkbox-checked .ant-checkbox-inner{
  background-color: #3e77ff;
}
.ant-input-group .ant-input{
  font-size: 13PX;
}
.boxLeftTopLogo {
  width: 130PX;
  height: 60PX;
  margin-right: 37PX;
}
.tryOut .logo-slogan-img {
  width: auto;
  height: 96PX;
}
.inner-h5 .logo-slogan-img {
  width: auto;
  height: 4.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/tryOut/index.vue